import React from "react";

import { Typography } from "../Typography/Typography";

import { ribbonColors, ribbonVariants, roundedBorders } from "./Ribbon.css";

export type RibbonColor = "lightGrey" | "lightYellow" | "lightPink" | "red" | "lightGreen" | "lightBlue" | "white";
export type RibbonVariant = "standard" | "rounded";
export type RibbonSize = "small" | "medium";

export type RibbonProps = {
  colour?: RibbonColor;
  variant?: RibbonVariant;
  size?: RibbonSize;
  children: React.ReactNode;
};

export const Ribbon: React.FC<RibbonProps> = ({
  colour = "lightPink",
  variant = "standard",
  size = "small",
  children
}) => {
  // Build className array
  const classNames: string[] = [ribbonColors[colour], ribbonVariants[variant]];

  // Add bottom border for rounded variants (excluding red and default)
  if (variant === "rounded") {
    classNames.push(roundedBorders[colour]);
  }

  // Map ribbon colours to typography colours
  const getTextColour = (ribbonColour: RibbonColor) => {
    switch (ribbonColour) {
      case "red":
        return "secondary-light";
      default:
        return "primary-dark";
    }
  };

  return (
    <div className={classNames.join(" ")}>
      <Typography
        as="span"
        variant={size === "small" ? "smallprint-sm-bold" : "smallprint-md-bold"}
        colour={getTextColour(colour)}
      >
        {children}
      </Typography>
    </div>
  );
};
